import paths from 'constants/paths';
import { Article as ArticleType } from 'data/SingleArticle/types';
import { organizationJsonLd } from './organizationJsonLd';

const { basePath } = paths;

/**
 * https://schema.org/Article
 */
export const articleJsonLd = ({ article }: { article: ArticleType }) => {
  const UNKNOWN_SLUG = 'unknown';
  const headline = article.title;
  const authorName = article?.author?.[0]?.name;
  const parentCategory = article?.categories?.[0];
  const parentCategorySlug = parentCategory
    ? parentCategory?.slug
    : UNKNOWN_SLUG;

  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline,
    image: [article.image.url],
    dateModified: article.editorialLastPublishedDateComputed,
    datePublished: article.editorialOriginalPublishDate,
    author: {
      '@type': 'Person',
      name: authorName,
    },
    description: article.shortDescription,
    articleSection: parentCategorySlug || UNKNOWN_SLUG,
    mainEntityOfPage: `https://zapier.com${basePath}/${article.slug}`,
    publisher: organizationJsonLd,
    name: headline,
  };
};
